import React from "react";
import {Text} from "@wakelet/ui-kit"
import {LanguageSelector, updateLang} from "../language/LanguageSelector";
import i18n from "i18next";
import {translate} from "../language/translate";

export const Footer = () => {
  return <div className="flex-grow flex flex-row justify-between items-center">
    <LanguageSelector countryCode={i18n.language} updateLang={updateLang}/>
    <ol className="font-medium flex flex-wrap gap-2 basis-1/2 justify-end">
      <li>
        <a href="https://wakelet.com/privacy.html">
          <Text>{translate("links.privacy", "common")}</Text>
        </a>
      </li>
      <li>
        <a href="https://wakelet.com/terms.html">
          <Text>{translate("links.terms", "common")}</Text>
        </a>
      </li>
      <li>
        <a href="https://wakelet.com/rules.html">
          <Text>{translate("links.rules", "common")}</Text>
        </a>
      </li>
    </ol>
  </div>
};